import axios from 'axios';
import { API_URL } from '../constants/constants';
import { auth } from '../firebase';
import logger from './logger';

// DEBUG: Log API URL at module load time
logger.debug('api.js: API_URL imported as:', API_URL);
logger.debug('api.js: process.env.REACT_APP_API_URL:', process.env.REACT_APP_API_URL);
logger.debug('api.js: typeof API_URL:', typeof API_URL);

// Create axios instance with default config
const api = axios.create({
  baseURL: API_URL,
  withCredentials: true
});

// DEBUG: Log the actual baseURL being used
logger.debug('api.js: Axios instance baseURL:', api.defaults.baseURL);

// Add request interceptor to include Authorization header
api.interceptors.request.use(
  async config => {
    // DEBUG: Log the actual URL being requested
    const fullUrl = `${config.baseURL}${config.url}`;
    logger.debug('api.js interceptor: Request URL:', config.url);
    logger.debug('api.js interceptor: baseURL:', config.baseURL);
    logger.debug('api.js interceptor: Full URL:', fullUrl);
    // Add Authorization header if user is authenticated
    if (auth && auth.currentUser) {
      try {
        const idToken = await auth.currentUser.getIdToken();
        if (idToken) {
          config.headers['Authorization'] = `Bearer ${idToken}`;
        }
      } catch (e) {
        // Ignore if unable to get token
      }
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

export default api;
